import { render, staticRenderFns } from "./CurrencyListV2.vue?vue&type=template&id=ab29952a&scoped=true"
import script from "./CurrencyListV2.vue?vue&type=script&lang=js"
export * from "./CurrencyListV2.vue?vue&type=script&lang=js"
import style0 from "./CurrencyListV2.vue?vue&type=style&index=0&id=ab29952a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab29952a",
  null
  
)

export default component.exports